module.exports = __webpack_public_path__ + "images/pro/payment-alipay-d534b5a7f5f1c4b41118ca18ebe33bc6.png";